var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4329 20.0018L11.3588 20.9893C10.5493 21.2485 10 22.0042 10 22.8566V26.6769C10 26.8558 10.1437 27 10.322 27H21.678C21.8563 27 22 26.8558 22 26.6769V22.8566C22 22.0042 21.4507 21.2485 20.6412 20.9893L17.5598 20",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19V20.0633C18 20.387 17.7979 20.6828 17.4808 20.8061C17.2195 20.908 16.8763 21 16.5 21C16.1237 21 15.7805 20.908 15.5192 20.8061C15.2021 20.6828 15 20.387 15 20.0633V19",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15.7927C19 17.5641 17.6571 19 16 19C14.3429 19 13 17.5641 13 15.7927C13 14.0214 14.3429 13 16 13C17.6571 13 19 14.0214 19 15.7927Z",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19V20.0633C8 20.387 7.79791 20.6828 7.48084 20.8061C7.21951 20.908 6.87631 21 6.5 21C6.12369 21 5.78049 20.908 5.51916 20.8061C5.20209 20.6828 5 20.387 5 20.0633V19",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.7927C10 17.5641 8.65713 19 7 19C5.34287 19 4 17.5641 4 15.7927C4 14.0214 5.34287 13 7 13C8.65713 13 10 14.0214 10 15.7927Z",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 27V24",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 27V24",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08228 20L2.25441 20.9846C1.50714 21.244 1 22.0003 1 22.8533V26.6767C1 26.8557 1.13266 27 1.29723 27H9",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21L8 20",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27V24",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19V20.0633C24 20.387 24.2021 20.6828 24.5192 20.8061C24.7805 20.908 25.1237 21 25.5 21C25.8763 21 26.2195 20.908 26.4808 20.8061C26.7979 20.6828 27 20.387 27 20.0633V19",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.7927C23 17.5641 24.3429 19 26 19C27.6571 19 29 17.5641 29 15.7927C29 14.0214 27.6571 13 26 13C24.3429 13 23 14.0214 23 15.7927Z",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9177 20L29.7456 20.9846C30.4929 21.244 31 22.0003 31 22.8533V26.6767C31 26.8557 30.8673 27 30.7028 27H23",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21L24 20",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29 27V24",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12V11.297C22 10.6115 21.5051 10.0039 20.7759 9.7955L18 9",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9L11.5326 9.79442C10.6196 10.0029 10 10.6109 10 11.2966V12",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8V9.06327C18 9.38702 17.7979 9.68283 17.4808 9.80608C17.2195 9.90797 16.8763 10 16.5 10C16.1237 10 15.7805 9.90797 15.5192 9.80608C15.2021 9.68283 15 9.38702 15 9.06327V8",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4.2582C19 6.3248 17.6571 8 16 8C14.3429 8 13 6.3248 13 4.2582C13 2.1916 14.3429 1 16 1C17.6571 1 19 2.1916 19 4.2582Z",
    stroke: "#FF9640",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.7f93f53256ff78f726bbae0413fc0ea7.svg";
export { ForwardRef as ReactComponent };